"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var BowSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M4.77152723,5.27982115 L7.63849198,7 L10.361508,7 L13.2284728,5.27982115 C14.4849396,4.53092957 16,5.4667511 16,6.8490332 C16,8.28301107 16,10.0503223 16,12.1509668 C16,13.6511536 14.3511505,14.420517 13.2284728,13.7201789 C12.803066,13.4675173 11.847411,12.8941243 10.361508,12 L7.63849198,12 L4.77152723,13.7201789 C3.50784302,14.450058 2,13.5484772 2,12.1509668 L2,6.8490332 C2,5.27982115 3.70485421,4.60382142 4.77152723,5.27982115 Z M3,6.8490332 L3,12.1509668 C3,12.7928467 3.701828,13.1761322 4.25703148,12.8626859 L7,11.2167566 L7,9.99975664 L5,10 L5,9 L7,8.99975664 L7,7.78275664 L4.25703148,6.13731408 C3.76142883,5.81190491 3,6.18553162 3,6.8490332 Z M13.7429685,6.13731408 C13.2286742,6.44442248 12.3143514,6.99290334 11,7.78275664 L11,8.99975664 L13,9 L13,10 L11,9.99975664 L11,11.2167566 L13.7429685,12.8626859 C14.1562347,13.1538849 15,12.9028473 15,12.1509668 C15,10.7466736 15,6.8490332 15,6.8490332 C15.0313873,6.41290283 14.5033112,5.7467804 13.7429685,6.13731408 Z M10,7.99975664 L8,7.99975664 L8,10.9997566 L10,10.9997566 L10,7.99975664 Z" })));
};
BowSmall.displayName = 'BowSmall';
exports.default = BowSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=BowSmall.js.map